module.exports = __webpack_public_path__ + "static/img/QRCode.a610ee5.png";